import { debounce, ListSubheader } from '@mui/material';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

import { SearchBox } from '@/components/molecules/SearchBox';
import { blockPropagation } from '@/utility/blockPropagation';

interface Props {
  onChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

export const SearchMenuItem: React.FC<Props> = (props: Props): React.ReactElement => {
  const { onChange } = props;

  return (
    <ListSubheader sx={styles.container}>
      <SearchBox
        fullWidth={true}
        onKeyDownCapture={blockPropagation}
        onChange={debounce(onChange, 250)}
      />
    </ListSubheader>
  );
};

const styles: Record<string, SystemStyleObject> = {
  container: {
    backgroundColor: 'transparent',
    py: 2,
  },
};
